<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Sesi Ujian">
            <common-training-header/>
        </a-page-header>

        <a-card type="inner" size="small">
            <a-table
                class="pcp-table"
                :dataSource="items.class_sessions"
                rowKey="id"
                :loading="loading"
                :pagination="false"
                :defaultExpandAllRows="true"
                >

                <a-table-column key="class_session" title="Kelas" className="text-small text-left">
                    <template slot-scope="record">
                        {{ record.name }}
                    </template>
                </a-table-column>

                <p slot="expandedRowRender" slot-scope="record" style="margin: 0">
                    <a-table
                        class="pcp-table"
                        :dataSource="record.sessions"
                        rowKey="id"
                        :loading="loading"
                        :pagination="false"
                        bordered
                    >

                        <a-table-column key="session" title="Sesi Pelatihan" className="align-center text-small text-left">
                            <template slot-scope="innerRecord">
                                {{ innerRecord.name }}
                            </template>
                        </a-table-column>

                        <a-table-column key="inspirator" title="Inspirator" className="align-center text-small text-left">
                            <template slot-scope="innerRecord">
                                {{ innerRecord.inspirator.name }}
                            </template>
                        </a-table-column>

                        <a-table-column key="schedule_session" title="Jadwal Sesi" className="align-center text-small text-left">
                            <template slot-scope="innerRecord">
                               <a-tooltip>
                                    <template slot="title">
                                    Sesi dimulai
                                    </template>
                                    <a-icon type="calendar" /> <strong> {{ moment(innerRecord.session_time_start).format('DD MMMM YYYY HH:mm:ss') }}</strong>
                                </a-tooltip>
                                <br />
                                s/d
                                <br />
                                <a-tooltip>
                                    <template slot="title">
                                    Sesi berakhir
                                    </template>
                                    <a-icon type="calendar" /> <strong> {{ moment(innerRecord.session_time_end).format('DD MMMM YYYY HH:mm:ss') }}</strong>
                                </a-tooltip>
                            </template>
                        </a-table-column>

                        <a-table-column key="schedule" title="Jadwal Ujian" className="align-center text-small text-left">
                            <template slot-scope="innerRecord">
                                <template v-if="innerRecord.actual_exam_time_end != null">
                                    <a-tooltip>
                                        <template slot="title">
                                        Ujian dimulai
                                        </template>
                                        <a-icon type="calendar" />
                                        <strong> {{ moment(innerRecord.actual_exam_time_start).format('DD MMMM YYYY HH:mm:ss') }} </strong>
                                    </a-tooltip>
                                    <br />
                                    s/d
                                    <br />
                                    <a-tooltip>
                                        <template slot="title">
                                        Ujian berakhir
                                        </template>
                                        <a-icon type="calendar" /><strong> {{ moment(innerRecord.actual_exam_time_end).format('DD MMMM YYYY HH:mm:ss') }}</strong>
                                    </a-tooltip>
                                    <br />
                                    <a-tooltip>
                                        <template slot="title">
                                        Durasi
                                        </template>
                                        ({{ parseInt(momentCustom.duration(moment(innerRecord.actual_exam_time_end).diff(moment(innerRecord.actual_exam_time_start))).asMinutes()).toFixed(0) }} Menit)
                                    </a-tooltip>
                                </template>
                                <template v-else>
                                    <a-icon type="calendar" />
                                    <strong> {{ moment(innerRecord.exam_time_start).format('DD MMMM YYYY') }} </strong> <br/>
                                    <a-icon type="schedule" />
                                    {{ moment(innerRecord.exam_time_start).format('HH:mm:ss') }} - {{ moment(innerRecord.exam_time_start).add(innerRecord.exam_duration, 'minutes').format('HH:mm:ss') }}
                                    <br />
                                    <a-tooltip>
                                        <template slot="title">
                                        Durasi
                                        </template>
                                        ({{ innerRecord.exam_duration }} Menit)
                                    </a-tooltip>
                                </template>
                            </template>
                        </a-table-column>

                        <a-table-column key="exam_status" title="Status" className="align-center text-small text-left">
                            <template slot-scope="innerRecord">
                                <div style="text-align: center">
                                    <a-tag :color="examColor(innerRecord.exam_status.code)">
                                        {{ innerRecord.exam_status.text }}
                                    </a-tag>
                                </div>
                            </template>
                        </a-table-column>

                        <a-table-column key="action" title="Action" className="align-center text-small text-left">
                            <template slot-scope="innerRecord">
                                <div v-if="innerRecord.exam_status.code == 'ONGOING'">
                                    <a-button size="small"  style="background: #f50;color: #fff" :loading="processing" @click="(e) => showConfirmStopExam(innerRecord.id)" block >
                                        Stop Ujian <a-icon type="border" />
                                    </a-button>
                                </div>
                                <div v-else-if="innerRecord.exam_status.code != 'CANNOT_START'">
                                    <a-button type="primary" size="small" :disabled="innerRecord.exam_status.code == 'COMPLETED' ? true : false" :loading="processing" @click="(e) => showConfirmStartExam(innerRecord.id)" block >
                                        Mulai Ujian <a-icon type="play-square" />
                                    </a-button>
                                </div>
                                <div v-else-if="innerRecord.pretest_id != null">
                                    <div v-if="innerRecord.pretest_status.code == 'ONGOING'">
                                        <a-button size="small"  style="background: #f50;color: #fff" :loading="processing" @click="(e) => showConfirmStopPretest(innerRecord.id)" block >
                                            Stop PreTest <a-icon type="border" />
                                        </a-button>
                                    </div>
                                    <div v-else-if="innerRecord.pretest_status.code != 'CANNOT_START'">
                                        <a-button type="primary" size="small" :disabled="innerRecord.pretest_status.code == 'COMPLETED' ? true : false" :loading="processing" @click="(e) => showConfirmStartPretest(innerRecord.id)" block >
                                            Mulai PreTest <a-icon type="play-square" />
                                        </a-button>
                                    </div>
                                </div>
                            </template>
                        </a-table-column>

                        <a-table-column key="schedule_remid" title="Jadwal Remedi" className="align-center text-small text-left">
                            <template slot-scope="innerRecord">
                                <template v-if="innerRecord.actual_remid_time_end != null">
                                    <a-tooltip>
                                        <template slot="title">
                                        Remedi dimulai
                                        </template>
                                        <a-icon type="calendar" />
                                        <strong> {{ moment(innerRecord.actual_remid_time_start).format('DD MMMM YYYY HH:mm:ss') }} </strong>
                                    </a-tooltip>
                                    <br />
                                    s/d
                                    <br />
                                    <a-tooltip>
                                        <template slot="title">
                                        Remedi berakhir
                                        </template>
                                        <a-icon type="calendar" /><strong> {{ moment(innerRecord.actual_remid_time_end).format('DD MMMM YYYY HH:mm:ss') }}</strong>
                                    </a-tooltip>
                                    <br />
                                    <a-tooltip>
                                        <template slot="title">
                                        Durasi
                                        </template>
                                        ({{ parseInt(momentCustom.duration(moment(innerRecord.actual_remid_time_end).diff(moment(innerRecord.actual_remid_time_start))).asMinutes()).toFixed(0) }} Menit)
                                    </a-tooltip>
                                </template>
                                <template v-else>
                                    <a-icon type="calendar" />
                                    <strong> {{ moment(innerRecord.remid_time_start).format('DD MMMM YYYY') }} </strong> <br/>
                                    <a-icon type="schedule" />
                                    {{ moment(innerRecord.remid_time_start).format('HH:mm:ss') }} - {{ moment(innerRecord.remid_time_start).add(innerRecord.exam_duration, 'minutes').format('HH:mm:ss') }}
                                    <br />
                                    <a-tooltip>
                                        <template slot="title">
                                        Durasi
                                        </template>
                                        ({{ innerRecord.exam_duration }} Menit)
                                    </a-tooltip>
                                </template>
                            </template>
                        </a-table-column>

                        <a-table-column key="remid_status" title="Status Remedi" className="align-center text-small text-left">
                            <template slot-scope="innerRecord">
                                <div style="text-align: center">
                                    <a-tag :color="examColor(innerRecord.remid_status.code)">
                                        {{ innerRecord.remid_status.text }}
                                    </a-tag>
                                </div>
                            </template>
                        </a-table-column>

                        <a-table-column key="action_remid" title="Action Remedi" className="align-center text-small text-left">
                            <template slot-scope="innerRecord">
                                <div v-if="innerRecord.remid_status.code == 'ONGOING'">
                                    <a-button size="small"  style="background: #f50;color: #fff"
                                                :loading="processing"
                                                @click="(e) => showConfirmStopRemid(innerRecord.id)"
                                                block >
                                        Stop Remedi <a-icon type="border" />
                                    </a-button>
                                </div>
                                <div v-else-if="innerRecord.remid_status.code != 'CANNOT_START'">
                                    <a-button type="primary" size="small"
                                        :disabled="disableRemid(innerRecord)"
                                        :loading="processing"
                                        @click="(e) => showConfirmStartRemid(innerRecord.id)"
                                        block >
                                        Mulai Remedi <a-icon type="play-square" />
                                    </a-button>
                                </div>
                            </template>
                        </a-table-column>

                        <a-table-column key="report" title="Report" className="align-center text-small text-center">
                            <template slot-scope="innerRecord">
                                <a-button size="small" @click="examReport(innerRecord)">Report</a-button>
                            </template>
                        </a-table-column>

                    </a-table>
                </p>

            </a-table>
        </a-card>
    </div>
</template>

<script>
import momentCustom from 'moment'

export default {
    created() {
        this.getItems();
    },
    data() {
        return {
            momentCustom,
            form: this.$form.createForm(this),
            loading: false,
            processing: false,
            visible: false,
            items: {},
        };
    },
    computed: {
        date(){
            var date = new Date();
            return date
        },
    },
    methods: {
        examColor(code){
            switch(code){
                case 'NOT_STARTED':
                    return 'red'
                case 'ONGOING':
                    return 'blue'
                case 'COMPLETED':
                    return 'green'
            }
        },
        getItems() {
            this.loading = true;
            this.$http
                .get(this.routeUri("api.classical-exam.sessions"))
                .then(response => {
                    this.items = response.data
                })
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false));
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    });
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                });
            }
        },
        start(session) {
            this.processing = true
            this.$http
                .put(this.routeUri("api.classical-exam.start", {session: session}) + '?' + this.$qs.stringify({type: 'exam'}))
                .then(response => {
                    this.getItems()
                })
                .catch(error => this.handleResponseError(error.response.data))
                .finally(() => (this.processing = false));
        },
        stop(session) {
            this.processing = true
            this.$http
                .put(this.routeUri("api.classical-exam.stop", {session: session}) + '?' + this.$qs.stringify({type: 'exam'}))
                .then(response => {
                    this.getItems()
                })
                .catch(error => this.handleResponseError(error.response.data))
                .finally(() => (this.processing = false));
        },
        startPretest(session) {
            this.processing = true
            this.$http
                .put(this.routeUri("api.classical-exam.start", {session: session}) + '?' + this.$qs.stringify({type: 'pretest'}))
                .then(response => {
                    this.getItems()
                })
                .catch(error => this.handleResponseError(error.response.data))
                .finally(() => (this.processing = false));
        },
        stopPretest(session) {
            this.processing = true
            this.$http
                .put(this.routeUri("api.classical-exam.stop", {session: session}) + '?' + this.$qs.stringify({type: 'pretest'}))
                .then(response => {
                    this.getItems()
                })
                .catch(error => this.handleResponseError(error.response.data))
                .finally(() => (this.processing = false));
        },
        startRemid(session) {
            this.processing = true
            this.$http
                .put(this.routeUri("api.classical-exam.start", {session: session}) + '?' + this.$qs.stringify({type: 'remid'}))
                .then(response => {
                    this.getItems()
                })
                .catch(error => this.handleResponseError(error.response.data))
                .finally(() => (this.processing = false));
        },
        stopRemid(session) {
            this.processing = true
            this.$http
                .put(this.routeUri("api.classical-exam.stop", {session: session}) + '?' + this.$qs.stringify({type: 'remid'}))
                .then(response => {
                    this.getItems()
                })
                .catch(error => this.handleResponseError(error.response.data))
                .finally(() => (this.processing = false));
        },
        showConfirmStartPretest(session) {
            var msg = 'Anda yakin ingin memulai PreTest?'

            this.$confirm({
                title: 'Konfirmasi',
                content: msg,
                onOk: () => {
                    this.startPretest(session)
                },
                onCancel() {},
                class: 'test',
            });
        },
        showConfirmStopPretest(session) {
            var msg = 'Anda yakin ingin menghentikan PreTest?'

            this.$confirm({
                title: 'Konfirmasi',
                content: msg,
                onOk: () => {
                    this.stopPretest(session)
                },
                onCancel() {},
                class: 'test',
            });
        },
        showConfirmStartExam(session) {
            var msg = 'Anda yakin ingin memulai ujian?'

            this.$confirm({
                title: 'Konfirmasi',
                content: msg,
                onOk: () => {
                    this.start(session)
                },
                onCancel() {},
                class: 'test',
            });
        },
        showConfirmStartRemid(session) {
            var msg = 'Anda yakin ingin memulai remedi?'

            this.$confirm({
                title: 'Konfirmasi',
                content: msg,
                onOk: () => {
                    this.startRemid(session)
                },
                onCancel() {},
                class: 'test',
            });
        },
        showConfirmStopExam(session) {
            var msg = 'Anda yakin ingin mengakhiri ujian?'

            this.$confirm({
                title: 'Konfirmasi',
                content: msg,
                onOk: () => {
                    this.stop(session)
                },
                onCancel() {},
                class: 'test',
            });
        },
        showConfirmStopRemid(session) {
            var msg = 'Anda yakin ingin mengakhiri remedi?'

            this.$confirm({
                title: 'Konfirmasi',
                content: msg,
                onOk: () => {
                    this.stopRemid(session)
                },
                onCancel() {},
                class: 'test',
            });
        },
        disableExam(code){
            return code != 'NOT_STARTED' ? true : false
        },
        disableRemid(record){
            if(record.remid_status.code == 'COMPLETED')
                return true

            if(record.classical_verification_level < 4)
                return true

            return false
        },
        examReport(session) {
            let params = {
                session: session.id,
                class: session.class_id,
                previous: this.currentRoute
            }

            window.location.href = this.routeUri('admin.classical.exam.sessions.report', {
                session_hash: session.hash
            }) + '?' + this.$qs.stringify(params)
        }
    }
};
</script>


